<div>
	<!-- {{ salon.getName() }} -->
	<div [innerHtml]="salonCancellationPolicy" class="sm-cancellation-policy"></div>
	<a class='sm-powered-by' href='https://salonmonster.com/?src=bookingwidget'>{{ 'FOOTER.POWERED_BY' | translate }}</a>
</div>
